import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';

export const useInsertContent = () => {
  const { htmlEditorRef } = useWYSIWYGContext();
  const thisEditor = htmlEditorRef?.current;

  return (content: string) => {
    if (thisEditor) {
      thisEditor.selection.setContent(content);
      thisEditor.focus();
    }
  };
};
